const ChevronLeft = () => {
  return (
    <svg viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.24219 9.48438L1.99955 5.24173L6.24219 0.999094"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export default ChevronLeft;
